import { render, staticRenderFns } from "./kickstarterDashboard.vue?vue&type=template&id=3ab8e7ee&scoped=true&"
import script from "./kickstarterDashboard.vue?vue&type=script&lang=js&"
export * from "./kickstarterDashboard.vue?vue&type=script&lang=js&"
import style0 from "./kickstarterDashboard.vue?vue&type=style&index=0&id=3ab8e7ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab8e7ee",
  null
  
)

export default component.exports